import React from "react";
import { FiDownload, FiFolder, FiMail, FiShield } from "react-icons/fi";
import TerminalText from "./TerminalText";
import { rotatingCapabilities, widgets } from "./data";

function HeroCommandCenter() {
  return (
    <section className="hero-section" id="home">
      <div className="hero-copy">
        <p className="system-path">/root/e-ops/command-center</p>
        <h1>
          Edwin "E" Arzu
          <span>IT/Cybersecurity Professional</span>
        </h1>
        <p className="hero-subtitle">
          I support enterprise systems, users, networks, cloud platforms, and compliance initiatives in real operational environments.
        </p>
        <div className="terminal-line">
          <span>$ run capability-scan --module </span>
          <TerminalText phrases={rotatingCapabilities} />
        </div>
        <div className="hero-actions">
          <a href="#projects"><FiFolder /> View Projects</a>
          <a href="/Edwin-Arzu-Resume.pdf" download><FiDownload /> Download Resume</a>
          <a href="#contact"><FiMail /> Contact Me</a>
        </div>
      </div>

      <div className="command-frame" aria-label="Cybersecurity dashboard">
        <div className="frame-toolbar">
          <span />
          <span />
          <span />
          <strong>E-OPS LIVE SESSION</strong>
        </div>
        <div className="radar-card">
          <div className="radar-sweep" />
          <FiShield />
          <p>Zero critical alerts</p>
        </div>
        <div className="widget-grid">
          {widgets.map(([title, value, detail]) => (
            <article className="status-widget" key={title}>
              <small>{title}</small>
              <strong>{value}</strong>
              <p>{detail}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HeroCommandCenter;
